import { render, staticRenderFns } from "./RegBasicClose.vue?vue&type=template&id=23c82ba0"
import script from "./RegBasicClose.vue?vue&type=script&lang=js"
export * from "./RegBasicClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports